module.exports = __webpack_public_path__ + "distribution/img/fenxiangkanjia.1a4dc815.png";